<template>
	<md-card-content>
		<div class="md-layout">
			<div class="md-layout-item md-size-50">
				<md-field class="md-invalid">
					<label>Nom</label>
					<md-input v-model="insect.name" name="name" type="text" md-counter="45" required></md-input>
					<validation-error :errors="apiValidationErrors.name"/>
				</md-field>
			</div>
			<div class="md-layout-item md-size-50">
				<md-checkbox class="mt-4" v-model="insect.isActive">Actif</md-checkbox>
			</div>
		</div>
		<div class="md-layout mt-4">
			<div class="md-layout-item md-size-50" v-if="insect.path">
				<div class="h-full">
					<h4 class="mb-1"><b>Photo actuel</b> (si vous en sélectionnez une autre, celle-ci sera remplacée)
					</h4>
					<div class="flex items-center">
						<div>
							<md-button class="md-icon-button md-raised md-info"
									   :href="insect.url" target="_blank">
								<i class="md-icon fa fa-download"/>
							</md-button>
							<md-tooltip md-direction="top">Voir la photo</md-tooltip>
						</div>
						<span class="ml-2">{{ formatFilePath(insect.path) }}</span>
					</div>
				</div>
			</div>
			<div class="md-layout-item md-size-50">
				<md-field class="md-invalid">
					<label>Fichier</label>
					<md-file name="file" @change="selectFile"
							 accept=".jpg"></md-file>
					<validation-error marge="ml-2" :errors="apiValidationErrors.file"/>
				</md-field>
			</div>
		</div>
	</md-card-content>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
	name: "InsectForm",
	components: {
		ValidationError
	},
	mixins: [formMixin],
	props: {
		insect: {
			type: Object,
			default() {
				return {
					name: '',
					isActive: true,
                    path: null,
					file: null,
					url: ''
				}
			}
		},
		errors: Array
	},
	methods: {
		selectFile(e) {
			this.resetApiValidation();
			const file = e.target.files[0]
			if (file.size > 2000000) {
				this.setApiValidation([{
					detail: 'Le fichier est trop volumineux. Taille maximale : 2 Mo.',
					source: { pointer: '/data/attributes/file' }
				}]);
			} else {
				this.insect.file = file
			}
		},
		formatFilePath(path = '') {
			return path.slice(5)
		},
	},
	watch: {
		errors: function (newVal, oldVal) {
			this.resetApiValidation();
			if (newVal) {
				this.setApiValidation(newVal);
			}
		}
	}
}
</script>

<style scoped lang="scss">
::v-deep {
	.md-layout-item {
		h4 {
			font-size: .75rem;
		}

		.md-button {
			width: auto;
			margin: 0;
			padding: 5px;
			height: 27px;
			min-width: 27px;
			line-height: 27px;

			.md-icon {
				font-size: .875rem !important;
				min-width: .875rem !important;
				height: .875rem !important;
			}
		}
	}
}
</style>
